import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

let UiCAccountDataCardPixComponent = class UiCAccountDataCardPixComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], UiCAccountDataCardPixComponent.prototype, "accountDataAttributeList", void 0);
__decorate([
    Input()
], UiCAccountDataCardPixComponent.prototype, "accountDataCardTitle", void 0);
UiCAccountDataCardPixComponent = __decorate([
    Component({
        selector: 'ui-c-account-data-card-pix',
        template: "<ng-container>\n  <ion-row class=\"ui-c-account-data-card-pix\">\n    <ion-col size=\"12\"*ngFor=\"let accountDataAttribute of accountDataAttributeList\">\n      <div class=\"detail-item\">\n        <ion-item class=\"ion-item-select\">\n          <ion-label >{{accountDataAttribute.attributeName}}</ion-label>\n          <ion-input type=\"text\" [value]=\"accountDataAttribute.attributeValue\" [readonly]=\"true\">\n          </ion-input>\n        </ion-item>\n      </div>\n    </ion-col>\n  </ion-row>\n</ng-container>\n"
    })
], UiCAccountDataCardPixComponent);

let UiCAccountDataCardPixModule = class UiCAccountDataCardPixModule {
};
UiCAccountDataCardPixModule = __decorate([
    NgModule({
        declarations: [UiCAccountDataCardPixComponent],
        imports: [
            CommonModule,
            IonicModule
        ],
        exports: [UiCAccountDataCardPixComponent]
    })
], UiCAccountDataCardPixModule);

/*
 * Public API Surface of ui-c-account-data-card-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCAccountDataCardPixComponent, UiCAccountDataCardPixModule };
//# sourceMappingURL=wlp-ui-c-account-data-card-pix.js.map
